<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--CARD START-->
        <div>
            <div class="flex items-center">
                <div
                    class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconNotesSVG class="w-24 h-24"/>
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ $t('info.notifications_via_email') }}</span>
            </div>
            <span class="mt-16 self-label">{{ $t('info.subs_to_email') }}</span>
            <span class="text-base font-semibold sm:text-md">{{ $t('info.chosen') }}: {{ numOfSubscriptions }}</span>
            <button @click="initMultiSelects"
                    v-if="(customerInfo.role === 'travel_manager' || customerInfo.customertype === 'P')"
                    class="mt-16 self-btn-plain" data-open-modal="subscriptions">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconPencilSVG/>
                                        </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!-- CARD END -->
        <!-- SUBSCRIPTIONS MODAL START -->
        <div class="micromodal" id="subscriptions" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.edit_subs') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG/>
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div v-for="contact in filteredEmails" :key="contact.communication_device_id"
                                 class="w-full self-form-wrap-item">
                                <div>
                                    <label class="e5-form-label" for="epost">{{ contact.name }}</label>
                                    <div class="flex items-center">
                                        <input type="text" id="epost" disabled placeholder="" name="epost"
                                               :value="contact.value"
                                               class="e5-input">
                                    </div>
                                </div>
                                <div class="mt-10">
                                    <label class="e5-form-label"
                                           for="tellimused">{{ $t('info.subs_emails_notif') }}</label>
                                    <div class="relative">
                                        <div class="self-form-select-wrap">
                                            <select name="tellimused" id="tellimused" multiple
                                                    :class="'contact-' + contact.communication_device_id">
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex items-center justify-end w-full px-8 pt-16">
                                    <button @click="clearSubscriptions(contact.communication_device_id)"
                                            class="self-btn-plain-alert">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG/>
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.unsub') }}</span>
                                    </button>
                                </div>
                            </div>
                            <div aria-labelledby="hiddenrow" class="flex flex-wrap w-full max-h-0 overflow-hidden">
                                <div :class="['w-full self-form-wrap-item', { 'e5-error': !isEmailFormatCorrect }]">
                                    <label class="e5-form-label" for="epost">{{ $t('info.new_business_email') }}</label>
                                    <div class="flex items-center">
                                        <input type="text" id="epost" placeholder="" name="epost" v-model="newEmail"
                                               class="e5-input">
                                    </div>
                                </div>
                                <div class="w-full self-form-wrap-item">
                                    <label class="e5-form-label"
                                           for="tellimused">{{ $t('info.subs_emails_notif') }}</label>
                                    <div class="relative">
                                        <div class="self-form-select-wrap">
                                            <select name="tellimused" id="tellimused" multiple
                                                    class="contact-newEmail"></select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="customerInfo.customertype === 'O'"
                                 class="flex items-center justify-between w-full px-8 pt-16">
                                <button ref="animateToggleButtonAddEmail"
                                        aria-expanded="false"
                                        id="hiddenrow" class="self-btn-plain"
                                        @click="animatetoggle('animateToggleButtonAddEmail')"
                                        data-toggle="animatetoggle">
                                    <span class="self-btn-plain__text">{{ $t('info.add_subs_email') }}</span>
                                    <span class="self-btn-plain__icon self-moreinfo-icon"><IconArrowFrwardSVG/></span>
                                </button>
                            </div>
                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button data-micromodal-close @click="confirmSubscriptions()"
                                            class="self-btn-primary">
                                        {{ $t('info.save') }}
                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG/>
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close class="self-btn-plain">
                      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                          <IconXSVG/>
                      </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- SUBSCRIPTION MODALS END -->
        <!-- DELETE SUBSCRIPTION CONFIRMATION START -->
        <div class="micromodal" id="deleteSubscriptionsConfirmation" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.unsub_confirm') }}</h2>
                        <button @click="undoSubscriptionDeletion()" class="micromodal__close" aria-label="Close modal"
                                data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG/>
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button data-micromodal-close class="self-btn-primary">
                                        {{ $t('info.yes') }}
                                    </button>
                                </div>

                                <div>
                                    <button @click="undoSubscriptionDeletion()" data-micromodal-close
                                            class="self-btn-plain">
                      <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                          <IconXSVG/>
                      </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- DELETE SUBSCRIPTION CONFIRMATION END -->
    </div>
</template>
<script lang="ts">

import IconNotesSVG from "@/assets/static/icons-src/icon-notes.svg";
import IconPencilSVG from "@/assets/static/icons-src/icon-pencil.svg";
import { Component, Vue, Watch } from "vue-property-decorator";
import AlertSummary from "@/components/AlertSummary.vue";
import IconXSVG from "@/assets/static/icons-src/icon-x.svg";
import IconArrowAltSVG from "@/assets/static/icons-src/icon-arrow-alt.svg";
import { ICustomer } from "@/domain/ICustomer";
import { IContacts } from "@/domain/IContacts";
import { ISubscriptions, ISubscriptionsRequest } from '@/domain/ISubscriptions'
import $ from "jquery";
import MicroModal from 'micromodal'
import store from '@/store'
import Choices from 'choices.js'
import UtilsMixin from "@/scripts/utils";
import { ISaveCommunicationDeviceRequest } from "@/domain/ISaveInfo";
import i18n from "@/i18n";
import IconArrowFrwardSVG from "@/assets/static/icons-src/icon-arrow-forward.svg";

interface ContactInstance {
    choices: any;
    selectedSubscriptions: any[];
    subscribeSet: Set<any>;
    unsubscribeSet: Set<any>;
    subscriptions: ISubscriptions;
    value: string;
    type: number;
}

@Component({
    components: {
        IconArrowFrwardSVG,
        AlertSummary,
        IconPencilSVG,
        IconXSVG,
        IconArrowAltSVG,
        IconNotesSVG
    },
    mixins: [UtilsMixin]
})
export default class Subscriptions extends Vue {
    private labels = {
        regular_est: this.customerInfo.customertype === 'P' ? this.$t('info.newsletter') : this.$t('info.newsletter_org'),
        regular_rus: this.$t('info.newsletter_rus'),
        pc_est: this.$t('info.newsletter_plat')
    }

    @Watch('$i18n.locale')
    onLocaleChange() {
        this.labels = {
            regular_est: this.customerInfo.customertype === 'P' ? this.$t('info.newsletter') : this.$t('info.newsletter_org'),
            regular_rus: this.$t('info.newsletter_rus'),
            pc_est: this.$t('info.newsletter_plat')
        }
    }

    private lastDeletedSubscription: string | null = null
    private lastDeletedSubscriptionCommdeviceId: string | null = null
    private contactsMap: { [deviceId: string]: ContactInstance } = {}

    newEmail = ''
    addEmailChoices = null
    newEmailSubscriptions = []

    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo
    }

    // Filter out all the E-mails and Business E-mails
    get filteredEmails(): IContacts[] {
        if (this.customerInfo.customertype === 'P') {
            return this.customerInfo.contacts.filter(contact =>
                contact.name === 'E-mail');
        } else {
            return this.customerInfo.contacts.filter(contact => contact.name === 'Business E-mail' && (contact.reminding_allowed || contact.mailing_allowed || contact.feedback_allowed || contact.billing_allowed)
            );
        }
    }

    get numOfSubscriptions(): number {
        let numOfSubscriptions = 0
        const contacts = this.filteredEmails
        contacts.forEach((contact) => {
            numOfSubscriptions += Object.entries(contact.subscriptions).filter(([, value]) => value === 1).length
        })
        return numOfSubscriptions
    }

    get isPlatinumCustomer(): boolean {
        if (this.customerInfo.customertype === "O") return false
        if (this.customerInfo.customer_categories) return this.customerInfo.customer_categories.find(category => category.category_name === 'Platinum Club') !== undefined
        return false
    }

    get isEmailFormatCorrect(): boolean {
        return !(this.newEmail === '' || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.newEmail));
    }

    // Function to add a new communication device
    private addCommunicationDevice(contact: IContacts): void {
        this.contactsMap[contact.communication_device_id] = {
            choices: null,
            selectedSubscriptions: [],
            subscribeSet: new Set(),
            unsubscribeSet: new Set(),
            subscriptions: contact.subscriptions,
            value: contact.value,
            type: contact.type
        };
    }

    // Function to update a communication device
    private updateCommunicationDevice(contact: IContacts): void {
        if (!this.contactsMap[contact?.communication_device_id]) return;
        this.contactsMap[contact.communication_device_id].subscribeSet = new Set()
        this.contactsMap[contact.communication_device_id].unsubscribeSet = new Set()
        this.contactsMap[contact.communication_device_id].subscriptions = contact.subscriptions
    }

    /**
     * Initialize choices.js component for selecting and deselcting subscriptions
     */
    initMultiSelects(): void {
        this.clearFields()
        const placeholderText = this.$t('reports.form.choose') as string
        Object.entries(this.contactsMap).forEach(([deviceId, contact]) => {
            contact.choices = new Choices(document.querySelector(`.contact-${deviceId}`), {
                removeItemButton: true,
                itemSelectText: placeholderText,
                noChoicesText: this.$t('reports.form.no_choices_to_choose_from') as string,
                allowHTML: true,
                shouldSortItems: true
            })
            const currentSubscriptions = contact.subscriptions;
            // eslint-disable-next-line eqeqeq
            if (!this.isPlatinumCustomer && this.customerInfo.customertype === 'P' && currentSubscriptions.pc_est == false) {
                // If private customer is not a platinum club member then should not be able to ADD pc_est subscription if it is disabled.
                // If it is enabled, should be able to remove.
                delete currentSubscriptions.pc_est
            }

            // Set the initial values for the choices component
            contact.choices.setChoices(
                Object.keys(currentSubscriptions).map(key => ({
                    value: key,
                    label: this.labels[key],
                    selected: currentSubscriptions[key] === 1
                })),
                'value',
                'label',
                false
            );
            const initialSet = new Set(
                Object.entries(currentSubscriptions)
                    .filter(([, value]) => value === 1)
                    .map(([key]) => key)
            );
            contact.choices.passedElement.element.addEventListener('removeItem', (event) => {
                const removedValue = event.detail.value as string;
                contact.selectedSubscriptions = $(event.target).val() as string[];
                if (initialSet.has(removedValue)) {
                    contact.unsubscribeSet.add(removedValue);
                    this.lastDeletedSubscription = removedValue;
                    this.lastDeletedSubscriptionCommdeviceId = deviceId
                    MicroModal.show('deleteSubscriptionsConfirmation');
                } else if (contact.subscribeSet.has(removedValue)) {
                    contact.subscribeSet.delete(removedValue);
                }
            });

            contact.choices.passedElement.element.addEventListener('addItem', (event) => {
                const addedValue = event.detail.value as string;
                contact.selectedSubscriptions = $(event.target).val() as string[];
                if (!initialSet.has(addedValue)) {
                    contact.subscribeSet.add(addedValue);
                } else if (contact.unsubscribeSet.has(addedValue)) {
                    contact.unsubscribeSet.delete(addedValue);
                }
            });
        });

        // Init multi select for adding new email
        this.initMultiSelectsForAddingEmail()
    }

    /**
     * Initialize choices.js element for adding new email
     */
    private initMultiSelectsForAddingEmail(): void {
        // Init choices component
        if (this.addEmailChoices) {
            this.addEmailChoices.destroy()
        }
        const placeholderText = this.$t('reports.form.choose') as string
        this.addEmailChoices = new Choices(document.querySelector(`.contact-newEmail`), {
            removeItemButton: true,
            itemSelectText: placeholderText,
            noChoicesText: this.$t('reports.form.no_choices_to_choose_from') as string,
            allowHTML: true,
            shouldSortItems: true
        })
        this.addEmailChoices.setChoices([{
            value: "regular_est",
            label: this.labels.regular_est,
            selected: true
        }], 'value',
        'label',
        false)
        this.newEmailSubscriptions.push("regular_est") // Initialize

        this.addEmailChoices.passedElement.element.addEventListener('change', (event) => {
            this.newEmailSubscriptions = $(event.target).val() as string[];
        });

        // Hide 'add new email' part if visible
        const button = this.$refs.animateToggleButtonAddEmail as HTMLElement;
        if (button?.getAttribute('aria-expanded') === 'true') {
            this.animatetoggle('animateToggleButtonAddEmail')
        }
    }

    /**
     * Clear all the selected subscriptions
     */
    clearSubscriptions(id: string): void {
        const currentSubscriptions = this.contactsMap[id].subscriptions;
        if (currentSubscriptions.pc_est) this.contactsMap[id].unsubscribeSet.add('pc_est')
        if (currentSubscriptions.regular_est) this.contactsMap[id].unsubscribeSet.add('regular_est')
        if (currentSubscriptions.regular_rus) this.contactsMap[id].unsubscribeSet.add('regular_rus')
        this.contactsMap[id].subscribeSet.clear()

        this.contactsMap[id].choices.removeActiveItems();
    }

    /**
     * Cancel deletion of subscriptions.
     *
     * Remove the just "deleted" subscription form the list of subs to unsubscribe and put it back to selected subscriptions list.
     */
    undoSubscriptionDeletion() {
        this.contactsMap[this.lastDeletedSubscriptionCommdeviceId].unsubscribeSet.delete(this.lastDeletedSubscription)
        this.contactsMap[this.lastDeletedSubscriptionCommdeviceId].selectedSubscriptions.push(this.lastDeletedSubscription)

        // Re-select the item by its value
        this.contactsMap[this.lastDeletedSubscriptionCommdeviceId].choices.setChoiceByValue(this.lastDeletedSubscription);

        this.lastDeletedSubscription = null
        this.lastDeletedSubscriptionCommdeviceId = null
    }

    /**
     * Send subscribe and unsubscribe requests based on lists of items to subscribe or unsubscribe.
     */
    async confirmSubscriptions() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (const [deviceId, contact] of Object.entries(this.contactsMap)) {
            for (const sub of contact.subscribeSet) {
                const request: ISubscriptionsRequest = {
                    email: contact.value,
                    list: sub.valueOf() as string,
                    email_type: contact.type as unknown as string
                };
                const success = await store.dispatch('subscribe', request)
                if (!success) {
                    this.requestErrorFunction()
                    return
                }
            }
            for (const sub of contact.unsubscribeSet) {
                const request: ISubscriptionsRequest = {
                    email: contact.value,
                    list: sub.valueOf() as string,
                    email_type: contact.type as unknown as string
                }
                const success = await store.dispatch('unsubscribe', request)
                if (!success) {
                    this.requestErrorFunction()
                    return
                }
            }
            contact.unsubscribeSet.clear()
            contact.subscribeSet.clear()
        }
        this.lastDeletedSubscription = null
        this.lastDeletedSubscriptionCommdeviceId = null

        // Add new Email if correct format
        if (this.isEmailFormatCorrect) {
            const request: ISaveCommunicationDeviceRequest = {
                customerId: this.customerInfo.customerid,
                type: 50,
                value: this.newEmail,
                communicationDeviceId: ''
            }
            const success = store.dispatch("saveCommunicationDevice", request);
            if (!success) {
                this.requestErrorFunction()
                return
            }

            // Add subscriptions
            if (this.newEmailSubscriptions.length > 0) {
                for (const sub of this.newEmailSubscriptions) {
                    const request: ISubscriptionsRequest = {
                        email: this.newEmail,
                        list: sub.valueOf() as string,
                        email_type: '50'
                    };
                    const success = await store.dispatch('subscribe', request)
                    if (!success) {
                        this.requestErrorFunction()
                        return
                    }
                }
            }
        }
        // Update customerinfo to display new subscriptions
        await store.dispatch("updateCustomerInfo")
    }

    private requestErrorFunction() {
        Vue.notify({
            group: 'api',
            title: 'Server error',
            text: 'Error while while modifying the subscriptions',
            type: 'warn'
        });
    }

    /**
     * Clear all the fields for when reopening the modal
     */
    clearFields() {
        this.newEmail = ''
        this.newEmailSubscriptions = []
        Object.entries(this.contactsMap).forEach(([deviceId, contact]) => {
            if (contact.choices) {
                contact.choices.destroy()
            }
        })
        this.contactsMap = {}
        this.filteredEmails.forEach((email) => {
            this.addCommunicationDevice(email)
        })
    }

    // Type Declarations for TypeScript to tell that these methods exist in utils.ts
    animatetoggle!: (ref: string) => void

    mounted() {
        this.filteredEmails.forEach((email) => {
            this.addCommunicationDevice(email)
        })
    }

    updated() {
        this.filteredEmails.forEach((email) => {
            this.updateCommunicationDevice(email)
        })
    }
}
</script>
<style scoped>

</style>
